<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('partnerPool.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="partnerPoolInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input v-model="partnerPoolInfo.conditions.partnerName" :placeholder="$t('partnerPool.selectName')"
              clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="partnerPoolInfo.conditions.partnerType" :placeholder="$t('partnerPool.selectPartner')"
              style="width:100%">
              <el-option v-for="(item, index) in partnerPoolInfo.partnerTypes" :key="index" :label="item.name"
                :value="item.partnerType"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="partnerPoolInfo.conditions.state" :placeholder="$t('partnerPool.selectStatus')"
              style="width:100%">
              <el-option :label="$t('partnerPool.enable')" value="Y"></el-option>
              <el-option :label="$t('partnerPool.disable')" value="N"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="_queryPartnerPoolMethod()">
              <i class="el-icon-search"></i>
              <span>{{ $t('partnerPool.query') }}</span>
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('partnerPool.partner') }}</div>
        <div class="">
          <el-button type="primary" size="small" @click="_openAddPartnerPoolModal()">
            {{ $t('partnerPool.add') }}
          </el-button>
        </div>
      </div>
      <div class="">
        <el-table :data="partnerPoolInfo.partnerPools" border style="width: 100%">
          <el-table-column prop="partnerName" :label="$t('partnerPool.name')" align="center"></el-table-column>
          <el-table-column prop="partnerTypeName" :label="$t('partnerPool.partner')" align="center"></el-table-column>
          <el-table-column :label="$t('partnerPool.status')" align="center">
            <template slot-scope="scope">
              {{ scope.row.state == 'Y' ? $t('partnerPool.enable') : $t('partnerPool.disable') }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" :label="$t('partnerPool.createTime')" align="center"></el-table-column>
          <el-table-column prop="remark" :label="$t('partnerPool.usage')" align="center"></el-table-column>
          <el-table-column :label="$t('partnerPool.operation')" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="_openEditPartnerPoolModel(scope.row)">
                {{ $t('partnerPool.edit') }}
              </el-button>
              <el-button type="text" size="small" @click="_openDeletePartnerPoolModel(scope.row)">
                {{ $t('partnerPool.delete') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="partnerPoolInfo.conditions.page"
          :page-size="partnerPoolInfo.conditions.row" layout="total, prev, pager, next"
          :total="partnerPoolInfo.total"></el-pagination>
      </div>
    </el-card>

    <add-partner-pool ref="addPartnerPool" @refresh="_queryPartnerPoolMethod"></add-partner-pool>
    <edit-partner-pool ref="editPartnerPool" @refresh="_queryPartnerPoolMethod"></edit-partner-pool>
    <delete-partner-pool ref="deletePartnerPool" @refresh="_queryPartnerPoolMethod"></delete-partner-pool>
  </div>
</template>

<script>
import { listPartnerPool, listPartnerAdapt } from '@/api/partner/partnerApi'
import AddPartnerPool from '@/components/partner/addPartnerPool/addPartnerPool'
import EditPartnerPool from '@/components/partner/editPartnerPool/editPartnerPool'
import DeletePartnerPool from '@/components/partner/deletePartnerPool/deletePartnerPool'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'PartnerPool',
  components: {
    AddPartnerPool,
    EditPartnerPool,
    DeletePartnerPool
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      partnerPoolInfo: {
        partnerPools: [],
        partnerTypes: [],
        total: 0,
        records: 1,
        moreCondition: false,
        ppId: '',
        conditions: {
          partnerName: '',
          partnerType: '',
          state: '',
          page: 1,
          row: 10,
          shopId: ''
        }
      }
    }
  },
  created() {
    this._loadListPaymentAdapt()
    this._listPartnerPools(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
  },
  methods: {
    handleCurrentChange(val) {
      this._listPartnerPools(val, this.DEFAULT_ROWS)
    },
    async _listPartnerPools(_page, _rows) {
      this.partnerPoolInfo.conditions.page = _page
      this.partnerPoolInfo.conditions.row = _rows
      this.partnerPoolInfo.conditions.shopId = getShopId()

      try {
        const res = await listPartnerPool(this.partnerPoolInfo.conditions)
        this.partnerPoolInfo.total = res.total
        this.partnerPoolInfo.records = res.records
        this.partnerPoolInfo.partnerPools = res.data
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    _openAddPartnerPoolModal() {
      this.$refs.addPartnerPool.open()
    },
    _openEditPartnerPoolModel(_partnerPool) {
      this.$refs.editPartnerPool.open(_partnerPool)
    },
    _openDeletePartnerPoolModel(_partnerPool) {
      this.$refs.deletePartnerPool.open(_partnerPool)
    },
    _queryPartnerPoolMethod() {
      this._listPartnerPools(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    async _loadListPaymentAdapt() {
      try {
        const res = await listPartnerAdapt({
          page: 1,
          row: 100
        })
        this.partnerPoolInfo.partnerTypes = res.data
      } catch (error) {
        console.error('请求失败处理', error)
      }
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}

.ibox-title {
  border-color: #e7eaec;
  border-style: solid solid none;
  border-width: 1px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 15px 15px 7px;
  min-height: 48px;
}

.ibox-content {
  background-color: #ffffff;
  color: inherit;
  padding: 15px 20px 20px 20px;
  border-color: #e7eaec;
  border-style: solid solid none;
  border-width: 1px;
}
</style>